<template>
  <el-dialog
      :visible.sync="dialogVisible"
      style="padding: 5px"
      append-to-body
      title="文件预览"
      top="0vh"
      width="80%">
    <pdf-viewer ref="pdfViewer" :pdf-url="pdfUrl"/>
  </el-dialog>
</template>

<script>
  import PdfViewer from "@/components/pdfViewer/PdfViewer.vue";

  export default {
    components: {PdfViewer},
    data() {
      return {
        dialogVisible: false,
        pdfUrl: "",
      };
    },
    methods: {
      open(url) {
        this.pdfUrl = window.config.basicServerUrl + url;
        this.dialogVisible = true;
      },
    },
  };
</script>
